module.exports = __webpack_public_path__ + "img/img6.36130ab8.png";